import { createFileRoute } from '@tanstack/react-router'
import { AuditorTimelineRoutePage } from '@/components/auditor-center/AuditorCyclePages'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline',
)({
  component: AuditorTimelineRoutePage,
})
